<template>
  <div class="form-fields mt-100 px-100">
    <template v-for="(field, index) in fieldData">
      <form-field-input
        :key="field.id"
        :input-id="field.inputId"
        :label="field.label"
        :placeholder="field.placeholder"
        :help-text="helpText(field.isRequired)"
        type="number"
        min="0"
        step=".5"
        :validation-errors="validationErrors[`steps.${stepId}.fields.${index}.value`]"
        v-model="field.value"
        v-if="field.fieldType === ENUMS.CustomFieldTypeEnum.Number.value"
      ></form-field-input>

      <form-field-date-picker
        :key="field.id"
        :input-id="field.inputId"
        :label="field.label"
        :placeholder="field.placeholder"
        :help-text="helpText(field.isRequired)"
        :validation-errors="validationErrors[`steps.${stepId}.fields.${index}.value`]"
        v-model="field.value"
        v-if="field.fieldType === ENUMS.CustomFieldTypeEnum.Date.value"
      ></form-field-date-picker>

      <form-field-time-picker
        :key="field.id"
        :input-id="field.inputId"
        :label="field.label"
        :placeholder="field.placeholder"
        :help-text="helpText(field.isRequired)"
        :validation-errors="validationErrors[`steps.${stepId}.fields.${index}.value`]"
        type="time"
        v-model="field.value"
        v-if="field.fieldType === ENUMS.CustomFieldTypeEnum.Time.value"
      ></form-field-time-picker>

      <form-field-select
        :key="field.id"
        :input-id="field.inputId"
        :label="field.label"
        :help-text="helpText(field.isRequired)"
        :validation-errors="validationErrors[`steps.${stepId}.fields.${index}.value`]"
        :is-multiple="(field.id === 'contact_tag_id')"
        v-model="field.value"
        v-if="field.fieldType === ENUMS.CustomFieldTypeEnum.DropDown.value"
      >
        <template v-if="field.id === 'campaign_id'">
          <option :value="null">Choose {{ field.placeholder }}</option>
          <option v-for="(option, index) in field.options" :value="index">{{ option }}</option>
        </template>
        <template v-else-if="field.id === 'contact_tag_id'">
          <option v-for="(label, id) in field.options" :value="id">{{ label }}</option>
        </template>
        <template v-else>
          <option v-for="(option, index) in field.options" :value="option">{{ option }}</option>
        </template>
      </form-field-select>

      <form-field-input
        :key="field.id"
        :input-id="field.inputId"
        :label="field.label"
        type="url"
        :help-text="helpText(field.isRequired)"
        :validation-errors="validationErrors[`steps.${stepId}.fields.${index}.value`]"
        v-model="field.value"
        v-if="field.fieldType === ENUMS.CustomFieldTypeEnum.Url.value"
      ></form-field-input>

      <form-field-phone
        :key="field.id"
        :input-id="field.inputId"
        :label="field.label"
        :placeholder="field.placeholder"
        :help-text="helpText(field.isRequired)"
        :validation-errors="validationErrors[`steps.${stepId}.fields.${index}.value`]"
        v-model="field.value"
        v-if="field.fieldType === ENUMS.CustomFieldTypeEnum.Phone.value"
      ></form-field-phone>

      <form-field-input
        :key="field.id"
        :input-id="field.inputId"
        :label="field.label"
        :placeholder="field.placeholder"
        :help-text="helpText(field.isRequired)"
        type="email"
        :validation-errors="validationErrors[`steps.${stepId}.fields.${index}.value`]"
        v-model="field.value"
        v-if="field.fieldType === ENUMS.CustomFieldTypeEnum.Email.value"
      ></form-field-input>

      <form-field-currency
        :key="field.id"
        :input-id="field.inputId"
        :label="field.label"
        :placeholder="field.placeholder"
        :help-text="helpText(field.isRequired)"
        :validation-errors="validationErrors[`steps.${stepId}.fields.${index}.value`]"
        v-model="field.value"
        v-if="field.fieldType === ENUMS.CustomFieldTypeEnum.Currency.value"
      ></form-field-currency>

      <form-field-textarea
        :key="field.id"
        :input-id="field.inputId"
        :label="field.label"
        :placeholder="field.placeholder"
        :help-text="helpText(field.isRequired)"
        :validation-errors="validationErrors[`steps.${stepId}.fields.${index}.value`]"
        v-model="field.value"
        v-if="field.fieldType === ENUMS.CustomFieldTypeEnum.TextArea.value"
      ></form-field-textarea>

      <div class="address_search">
        <form-field-input
          :key="field.id"
          :input-id="field.inputId"
          :label="field.label"
          :placeholder="field.placeholder"
          :help-text="helpText(field.isRequired)"
          :validation-errors="validationErrors[`steps.${stepId}.fields.${index}.value`]"
          v-model="field.value"
          v-if="field.fieldType === ENUMS.CustomFieldTypeEnum.Text.value"
        ></form-field-input>

        <div
          v-if="showPropertyResults && field.inputId === `property-streetaddress`"
          class="column is-full address_search--results">
          <p
            v-for="result in propertyResults"
            tabindex="-1"
            @click="applyAddress('property', result)"
            class="address_search--results--item dont-close-property-search-results">
            <strong class="dont-close-property-search-results">{{ result.house }} {{ result.street }},</strong>
            <small class="dont-close-property-search-results">{{result.city}}, {{result.state}}, {{result.zip}}</small>
          </p>
        </div>

        <div
          v-if="showContactResults && field.inputId === `contact-streetaddress`"
          class="column is-full address_search--results">
          <p
            v-for="result in contactResults"
            tabindex="-1"
            @click="applyAddress('contact', result)"
            class="address_search--results--item dont-close-contact-search-results">
            <strong class="dont-close-contact-search-results">{{ result.house }} {{ result.street }},</strong>
            <small class="dont-close-contact-search-results">{{result.city}}, {{result.state}}, {{result.zip }}</small>
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "CallScriptPublicStepFields",
  props: {
    fieldData: {
      type: Array,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    },
    validationErrors: {
      type: Object,
      default: () => []
    },
    reiRealEstatePropertyOptionsOpen: {
      type: Boolean
    },
    reiRealEstateContactOptionsOpen: {
      type: Boolean
    }
  },
  mounted() {
    this.setupAutoComplete('property')
    this.setupAutoComplete('contact')
  },
  data() {
    return {
      apiUrl: 'https://api.realestateapi.com/v2/AutoComplete',
      apiKey: process.env.MIX_REAL_ESTATE_API_KEY,
      propertyResults: [],
      contactResults: [],
      showPropertyResults: false,
      showContactResults: false,
    }
  },
  watch: {
    // This is important that this is in the LayoutPage via a global Listener
    'reiRealEstatePropertyOptionsOpen'(value) {
      console.log('is this property listener', value);
      this.showPropertyResults = value;
      this.propertyResults = [];
    },
    'reiRealEstateContactOptionsOpen'(value) {
      console.log('is this contact listener', value);
      this.showContactResults = value;
      this.contactResults = [];
    },
  },
  methods: {
    helpText(isRequired = 0) {
      if (isRequired === 1) {
        return '* required field';
      }

      return '';
    },
    async search(address) {
      if (!address) {
        return Promise.resolve(null);
      }
      if (address < 3) {
        return Promise.resolve(null);
      }

      const requestOptions = {
        method: "POST",
        mode: 'cors',
        headers: {
          "x-api-key": this.apiKey,
          "Content-Type": "application/json"
        },
        referrerPolicy: 'strict-origin-when-cross-origin',
        body: JSON.stringify({search: address})
      };

      return fetch(this.apiUrl, requestOptions)
        .then(response => {
          return response.json().then(data => {
            this.showResults = true;
            return data.data || null;
          }).catch(e => {
            console.error(e)
            return null;
          });
        }).catch(e => {
          console.error(e)
          return null;
        });
    },
    setupAutoComplete(type) {
      const hasAddressField = this.fieldData.find(field => field.inputId === `${type}-streetaddress`)

      if (!hasAddressField) return;

      const autoCompleteInput = document.getElementById(`${type}-streetaddress`);

      if (!autoCompleteInput) return

      autoCompleteInput.addEventListener('input', async (event) => {
        let query = event.target.value;
        if (query.length < 4) return;
        this.results = await this.search(query) || [];

        if (type === 'property') {
          this.propertyResults = this.results;
          this.showPropertyResults = true;
        }
        if (type === 'contact') {
          this.contactResults = this.results;
          this.showContactResults = true;
        }
      });
    },
    applyAddress(type, addressResult) {
      console.log(`applying ${type} address`, type, addressResult);

      if (type === 'property') {
        this.showPropertyResults = false;
        this.propertyResults = [];
      }
      if (type === 'contact') {
        this.showContactResults = false;
        this.contactResults = [];
      }

      this.fieldData.map(field => {
        if (field.inputId === `${type}-streetaddress`) {
          field.value = addressResult.house + ' ' + addressResult.street;
        }

        if (field.inputId === `${type}-city`) {
          field.value = addressResult.city;
        }

        if (field.inputId === `${type}-state`) {
          field.value = addressResult.state;
        }

        if (field.inputId === `${type}-postcode`) {
          field.value = addressResult.zip;
        }
      });

      this.$forceUpdate()
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.address_search {
  position: relative;
  width: 100%;

  &--results {
    position: absolute;
    top: 100%;
    left: 0.75rem;
    right: 0.75rem;
    z-index: 99999999999;
    width: calc(100% - 1.5rem);
    padding: 10px;
    background-color: $white;
    box-shadow: $box-shadow;

    &--item {
      margin-bottom: 3px;
      padding-bottom: 3px;
      border-bottom: 1px solid $border;
      color: $text-muted;
      font-size: 0.75rem;
      line-height: 1.3;
      cursor: pointer;

      strong {
        color: inherit;
      }

      &:hover {
        color: $primary;
      }
    }
  }
}
</style>
